module.exports = __webpack_public_path__ + "img/agricultura.7c2f1348.png";